// mutations
const SET_TEMP = (state, payload) => {
  state.temp = payload;
};
const SET_USERID = (state, payload) => {
  state.user_id = payload;
};
const SET_ID = (state, payload) => {
  state.id = payload;
};
const SET_RESSBYID = (state, payload) => {
  state.resByID = payload;
};
export default {
  SET_RESSBYID,
  SET_USERID,
  SET_TEMP,
  SET_ID
};
